import { render, staticRenderFns } from "./UploadBodDialog.vue?vue&type=template&id=5105cdba&scoped=true"
import script from "./UploadBodDialog.vue?vue&type=script&lang=js"
export * from "./UploadBodDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadBodDialog.vue?vue&type=style&index=0&id=5105cdba&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5105cdba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5105cdba')) {
      api.createRecord('5105cdba', component.options)
    } else {
      api.reload('5105cdba', component.options)
    }
    module.hot.accept("./UploadBodDialog.vue?vue&type=template&id=5105cdba&scoped=true", function () {
      api.rerender('5105cdba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UploadBodDialog.vue"
export default component.exports